module.exports = __webpack_public_path__ + "img/template-3.dc07c8a4.jpg";